const nodeEnv =  window.configs && window.configs.NODE_ENV !== "" 
? window.configs.NODE_ENV: process.env.NODE_ENV;
export const CANDIDATE_MENU = {
    MENU_ITEMS: [
        {
            name: "Mon Profil",
            route: "candidate-profile",
            filters: {
                hideWhenEmailUnconfirmed: false,
            },
        },
        {
            name: "Offres d'emploi",
            filters: {
                hideWhenEmailUnconfirmed: true,
            },
            items: [
                {
                    name: "Offres d'emploi",
                    route: "candidate-browse-missions",
                    altRoute: "offre-emploi-details",
                },
                {
                    name: "Mes Candidatures",
                    route: "candidate-applications",
                },
                {
                    name: "Offres de Remplacement reçues",
                    route: "candidate-assignment-offer",
                    hidden: nodeEnv !== "development",
                },
            ]
        },
        {
            name: "Mes candidatures",
            route: "candidate-applications",
            filters: {
                hideWhenEmailUnconfirmed: true,
            },
        },
        {
            name: "Vitalliance",
            hidden: nodeEnv !== "development",
            filters: {
                hideWhenEmailUnconfirmed: true,
            },
            items: [
                {
                    name: "Mon agence",
                    route: "candidate-agency",
                },
                {
                    name: "Mes documents",
                    route: "candidate-documents",
                    exADV: true,
                },
                {
                    name: "Actualités",
                    route: "candidate-news",
                },
                {
                    name: "Service RH Médiation",
                    route: "candidate-reclamation",
                },
                /*{
                    name: "Télégestion",
                    exADV: true,
                    route: "candidate-telemanagement",
                },*/
                // {
                //     name: "Notes de Service",
                //     route: "candidate-assignment-offer",
                // },
                // {
                //     name: "Actualités",
                //     route: "candidate-assignment-offer",
                // },
            ]
        },
        {
            name: "Mes documents",
            route: "candidate-documents",
            exADV: true,
            filters: {
                hideWhenEmailUnconfirmed: true,
            },
        },
        {
            name: "Support Technique",
            route: "candidate-support-technique",
            filters: {
                hideWhenEmailUnconfirmed: true,
            },
        },
    ]
};

export const MESSAGE_POPUP = {
  TYPE: 'adv_candidate'
};
